module.exports = __webpack_public_path__ + "img/score3.6c973582.jpg";